import { render, staticRenderFns } from "./CustomerAddressEditPopup.vue?vue&type=template&id=515632c4&"
import script from "./CustomerAddressEditPopup.vue?vue&type=script&lang=js&"
export * from "./CustomerAddressEditPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports